import { calendarHeander as Props } from "../../../types/calendar";
import useTranslation from "../../../helpers/translationTexts/useTranslation";
import { MonthTitle, MonthWrapper, NextMonthButton, PrevMonthButton, Wrapper } from "./CalendarHeader.components";

const CalendarHeader: React.FC<Props> = ({ monthOffset, setMonthOffset, toDayInfo }) => {
  const nextButtonDisabled: boolean = monthOffset === 0;
  const prevButtonDisabled: boolean = new Date(toDayInfo.year, toDayInfo.month) <= new Date(2022, 1);

  const monthText = useTranslation(toDayInfo.monthName);
  const day = toDayInfo.date;
  const year = toDayInfo.year;

  const handleMonthChange = (incr: number) => {
    setMonthOffset((prev) => prev + incr);
  };

  return (
    <Wrapper>
      <MonthWrapper>
        <PrevMonthButton handleMonthChange={handleMonthChange} isDisable={prevButtonDisabled} />
        <MonthTitle day={day} month={monthText} year={year} />
        <NextMonthButton handleMonthChange={handleMonthChange} isDisable={nextButtonDisabled} />
      </MonthWrapper>
    </Wrapper>
  );
};

export default CalendarHeader;
